import './index.less'
import { CloudDownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import UpvoteEyes from "@/components/UpvoteEyes";
import CommentInput from "@/components/CommentInput";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'

interface IProp {
  item: any;
  type: "faq" | "notice" | "feedback";
  questionId: string;
  classNames?: string;
  afterDelete?: (id: string) => void;
  afterSend?: (questionId: string, parentId: string) => void;
  handleReport?: (id: string) => void;
}
const defaultAnswerUserAvatar=require("@/assets/images/support/default-avatar.png")

const CommentItem =(props: IProp) => {
  const navigate = useNavigate();
  const { item, type, questionId, classNames, afterDelete, afterSend, handleReport } = props;
  const [activeComments, setActiveComments] = useState<string[]>([]);
  const { authorization, portalAuthorization, goLogin } = useGetLoginInfo();

  return <div className={`questions-detail-answer-content ${item.children.length ? 'has-children' : ''} ${classNames}`}>
    <div className="questions-detail-answer-user">
      <img src={item?.avatar || defaultAnswerUserAvatar} alt="" onClick={() => navigate(`/user-detail/${item.userId}`)}/>
      <span 
        onClick={() => navigate(`/user-detail/${item.userId}`)} 
        style={{cursor:'pointer', color: item.nickName === '社区小助手' ? '#1677ff' : '#000'}}
        >{item?.nickName || "社区小助手"}</span>
      <span className='time'>{item?.createTime}</span>
    </div>
    <div className="questions-detail-context">
      <div dangerouslySetInnerHTML={{ __html: item?.answer }} />
    </div>
    {/* 匹配dev和生产环境，手把手PC、固定id的链接，前后端保持一致 */}
    {item?.filePath && (
      <Button
        style={{ marginBottom: "12px" }}
        type="primary"
        icon={<CloudDownloadOutlined />}
        onClick={() => {
          if (portalAuthorization && authorization) {
            window.open(item?.filePath);
          } else {
            goLogin();
          }
        }}
      >
        附件下载
      </Button>
    )}
    <UpvoteEyes
      data={item}
      isEyes={false}
      upvoteType={item.type}
      type={type}
      showCommentIcon
      showMore
      showReport
      afterDelete={afterDelete}
      showCommentInput={() => {
        if (!activeComments.includes(item.id)) {
          setActiveComments((ids) => {
            const list = [...ids]
            list.push(item.id)
            return list
          })
        } else {
          setActiveComments((ids) => {
            const list = [...ids];
            const index = list.findIndex(v => v === item.id);
            list.splice(index, 1);
            return list
          })
        }
      }}
      handleReport={handleReport}
    />
    {
      activeComments.includes(item.id) && 
      <CommentInput
        className='show-top' 
        type={type} 
        questionId={questionId} 
        parentId={item.id}
        hideAvatar
        placeholder={`回复 ${item.userName}`}
        afterSend={afterSend}
      />
    }
  </div>
}

export default CommentItem;